import { useState, useEffect } from "react";
import clientsService from "../../../api/clientsService";
import techniciansService from "../../../api/techniciansService";
import branchesService from "../../../api/branchesService";

/**
 * Hook personalizado para cargar datos de selects (clientes, técnicos, sucursales)
 */
export const useCalendarData = () => {
  const [clientes, setClientes] = useState([]);
  const [sucursales, setSucursales] = useState([]);
  const [tecnicos, setTecnicos] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        const [cliRes, techRes] = await Promise.all([
          clientsService.getAll(),
          techniciansService.getAll(),
        ]);
        setClientes(cliRes.data.data || []);
        setTecnicos(techRes.data.data || []);
      } catch (err) {
        console.error("Error cargando datos:", err);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  const loadBranchesByClient = async (clientId) => {
    if (!clientId) {
      setSucursales([]);
      return [];
    }
    
    try {
      setLoading(true);
      const res = await branchesService.getByClient(clientId);
      const data = res.data.data || [];
      setSucursales(data);
      return data;
    } catch (err) {
      console.error("Error cargando sucursales:", err);
      setSucursales([]);
      return [];
    } finally {
      setLoading(false);
    }
  };

  return {
    clientes,
    sucursales,
    tecnicos,
    loading,
    loadBranchesByClient,
  };
};

